import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, computed } from 'vue'
import { useRouter } from 'vue-router'
import WeatherPanelUI from '@/components/top/panels/WeatherPanel/WeatherPanelUI.vue'
import { DefinitionInfoTopGraphicalMapPanelWeather } from '@/models/initData/DefinitionInfo'
import { usePresentStore } from '@/stores/presentStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { renderValue } from '@/lib/formatter'


export default /*#__PURE__*/_defineComponent({
  props: {
  cell: {
    type: Object as PropType<DefinitionInfoTopGraphicalMapPanelWeather>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const router = useRouter()
const presentStore = usePresentStore()
const initDataStore = useInitDataStore()

const getStationName = (stationId: string) => {
  const station = initDataStore.initData.stations.findById(stationId)

  return station?.name || ''
}

const cell = computed(() => props.cell)

const cellToParams = (cell: DefinitionInfoTopGraphicalMapPanelWeather) => {
  const { no, stationId } = cell.args
  const stationName = getStationName(stationId)
  const updatedAt = presentStore.getTime(stationId, 'HH:mm')
  const windDirection = presentStore.getValue(stationId, 'moveWdMin10')
  const windStrength = renderValue(presentStore.getValue(stationId, 'moveWsMin10'), 1)
  const maxWindDirection = presentStore.getValue(stationId, 'moveMaxWdMin10')
  const maxWindStrength = renderValue(presentStore.getValue(stationId, 'moveMaxWsMin10'), 1)
  const tempature = renderValue(presentStore.getValue(stationId, 'temp'), 1)
  const humid = renderValue(presentStore.getValue(stationId, 'humid1'), 1)
  const press = renderValue(presentStore.getValue(stationId, 'press1'), 1)
  const rainMin10 = renderValue(presentStore.getValue(stationId, 'moveRainMin10'), 1)
  const rainMin60 = renderValue(presentStore.getValue(stationId, 'moveRainMin60'), 1)
  const rainRui = renderValue(presentStore.getValue(stationId, 'rainRui'), 1)
  const rainfall = renderValue(presentStore.getValue(stationId, 'rainfall'), 1)

  return {
    no,
    stationName,
    updatedAt,
    windDirection,
    windStrength,
    maxWindDirection,
    maxWindStrength,
    tempature,
    humid,
    press,
    rainMin10,
    rainMin60,
    rainRui,
    rainfall,
  }
}

const params = computed(() => cellToParams(cell.value))

const onClick = () => {
  const stationId = cell.value.args.stationId
  const path = `/weather_detail/${stationId}`

  router.push(path)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WeatherPanelUI, _mergeProps({ onClick: onClick }, _unref(params)), null, 16))
}
}

})